import { Dialog, DialogContent, Box, DialogActions, FormHelperText, Button, IconButton, DialogTitle, Divider } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { cleanRichText } from '../../../utils/richText';
import RichTextEditor from '../../richText/RichTextEditor';
import useContentFormDialog from '../../richText/useContentFormDialog';
import '../../../css/users/addUserDialog.css';

export const ModifierConseignSecurite = ({ modifyConseignSecurite, setModifyConseignSecurite }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const machineDetailsData = useSelector((state) => state.MachineDetailsData);
    const dialogProps = useContentFormDialog();

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            Safety_instructions: machineDetailsData?.Safety_instructions || '',
        },
        validationSchema: Yup.object().shape({
            Safety_instructions: Yup.string().nullable(),
        }),
        onSubmit: async (values) => {
            try {
                const cleanedContent = cleanRichText(values.Safety_instructions);
                const response = await axios.patch(`machine/conseigne_securite/${id}`, { Safety_instructions: cleanedContent });
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Modifier les Mesures de prévention' }));
                    dispatch(setMachineDetailsData({ ...machineDetailsData, Safety_instructions: response.data.Safety_instructions }));
                    setModifyConseignSecurite(false);
                }
            } catch (error) {
                console.error('Error updating machine status:', error);
                CustomErrorLogger(error, 'Error updating machine conseigne_securite in ModifierConseignSecurite');
            }
        },
    });

    const { handleSubmit, values, touched, errors, setFieldValue } = formik;

    const handleClose = () => setModifyConseignSecurite(false);

    return (
        <Dialog open={modifyConseignSecurite} {...dialogProps}>
            <IconButton onClick={handleClose} className='addUser_icon_button'>
                <Iconify icon={"material-symbols:close"} className='addUser_close_icon' />
            </IconButton>
            <DialogTitle className='addUser_dialog_title'>{t('Modifier Mesures de prévention')}</DialogTitle>
            <Divider />
            <form className='contentFormDialog_form' onSubmit={handleSubmit}>
                <DialogContent className='addUser_dialog_content contentFormDialog_content'>
                    <Box className="addUser_helper_selct_box contentFormDialog_description">
                        <FormHelperText className="addUserInputTitle">{t('Mesures de prévention')}</FormHelperText>
                        <RichTextEditor
                            value={values.Safety_instructions}
                            onChange={(html) => setFieldValue('Safety_instructions', html)}
                            placeholder={t('Mesures de prévention')}
                        />
                        {touched?.Safety_instructions && errors?.Safety_instructions && (
                            <FormHelperText error>{errors.Safety_instructions}</FormHelperText>
                        )}
                    </Box>
                </DialogContent>
                <DialogActions className='addUser_dialog_actions'>
                    <Button className='addUser_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addUser_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};
